export default "__VITE_ASSET__518df803__"